import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsignmentResolver } from './app.resolver';
import { CartComponent } from './pages/cart/cart.component';
import { OrderConfirmationComponent } from './pages/order-confirmation/order-confirmation.component';
import { ProductsComponent } from './pages/products/products.component';
import { TerminalsComponent } from './pages/terminals/terminals.component';

const routes: Routes = [
  {
    path: 'terminals',
    children: [
      {
        path: '',
        component: TerminalsComponent,
      },
      {
        path: ':terminalId',
        redirectTo: ':terminalId/packages',
        pathMatch: 'full'
      },
      {
        path: ':terminalId/packages',
        component: ProductsComponent,
        resolve: { params: ConsignmentResolver }
      },
      {
        path: ':terminalId/confirmation/:id',
        component: OrderConfirmationComponent,
        resolve: { params: ConsignmentResolver }
      },
      {
        path: ':terminalId/cart',
        component: CartComponent,
        resolve: { params: ConsignmentResolver }
      },
      {
        path: '**',
        redirectTo: ''
      },
    ]
  },
  { path: '**', redirectTo: 'terminals', pathMatch: 'full' },
  { path: '', redirectTo: 'terminals', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false
    })
  ],
  exports: [RouterModule],
  providers: [ConsignmentResolver],
})
export class AppRoutingModule { }
